import { render, staticRenderFns } from "./traitement-en-cours.html?vue&type=template&id=47af9482&scoped=true&external"
import script from "./traitement-en-cours.js?vue&type=script&lang=js&external"
export * from "./traitement-en-cours.js?vue&type=script&lang=js&external"
import style0 from "./traitement-en-cours.scss?vue&type=style&index=0&id=47af9482&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af9482",
  null
  
)

export default component.exports